import React from "react";
import { ShareLine1 } from "../../icons/ShareLine1";
import "./style.css";

export const ShareLineWrapper = () => {
  return <ShareLine1 className="share-line" />;
};
